interface IGeoCoordsProps {
  maximumAge?: number;
}

export type TGeolCoord = GeolocationCoordinates | null;

export async function getGeoCoords(props?: IGeoCoordsProps): Promise<TGeolCoord> {
  const { maximumAge = 3600000 } = props || {};

  if (!navigator.geolocation) {
    return null;
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(({ coords }) => resolve(coords), reject, { maximumAge });
  });
}
